export default __webpack_public_path__ + "static/media/min.a1a8d36c.jpg";